import { API_BASE_URL } from '../config/api';

async function apiFetch<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options?.headers,
    },
  });

  const data = await res.json();

  if (!res.ok) {
    throw new Error((data as any).error || 'Request failed');
  }

  return data as T;
}

// Auth
export const authApi = {
  register: (email: string, password: string, displayName?: string) =>
    apiFetch<{ message: string }>('/api/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, displayName }),
    }),

  login: (email: string, password: string) =>
    apiFetch<{ user: { id: string; email: string; displayName: string } }>('/api/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  me: () =>
    apiFetch<{ user: { id: string; email: string; displayName: string } | null }>('/api/auth/me'),

  logout: () =>
    apiFetch<{ message: string }>('/api/auth/logout', { method: 'POST' }),

  verifyEmail: (token: string) =>
    apiFetch<{ message: string }>(`/api/auth/verify-email?token=${token}`),

  forgotPassword: (email: string) =>
    apiFetch<{ message: string }>('/api/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  resetPassword: (token: string, password: string) =>
    apiFetch<{ message: string }>('/api/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, password }),
    }),

  googleAuthUrl: () => `${API_BASE_URL}/api/auth/google`,
};

// Playlists
export const playlistApi = {
  list: () =>
    apiFetch<{ playlists: any[] }>('/api/playlists'),

  create: (name: string) =>
    apiFetch<{ playlist: any }>('/api/playlists', {
      method: 'POST',
      body: JSON.stringify({ name }),
    }),

  get: (id: string) =>
    apiFetch<{ playlist: any; songs: any[] }>(`/api/playlists/${id}`),

  update: (id: string, name: string) =>
    apiFetch<{ message: string }>(`/api/playlists/${id}`, {
      method: 'PUT',
      body: JSON.stringify({ name }),
    }),

  delete: (id: string) =>
    apiFetch<{ message: string }>(`/api/playlists/${id}`, { method: 'DELETE' }),

  addSong: (playlistId: string, songId: string) =>
    apiFetch<{ message: string }>(`/api/playlists/${playlistId}/songs`, {
      method: 'POST',
      body: JSON.stringify({ songId }),
    }),

  removeSong: (playlistId: string, songId: string) =>
    apiFetch<{ message: string }>(`/api/playlists/${playlistId}/songs/${songId}`, {
      method: 'DELETE',
    }),

  reorder: (playlistId: string, songIds: string[]) =>
    apiFetch<{ message: string }>(`/api/playlists/${playlistId}/songs/reorder`, {
      method: 'PUT',
      body: JSON.stringify({ songIds }),
    }),
};

// Songs
export const songApi = {
  list: (volume?: number) =>
    apiFetch<{ songs: any[] }>(`/api/songs${volume ? `?volume=${volume}` : ''}`),
};
